export default __webpack_public_path__ + "static/media/avatar.285ae32b.svg";